import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';
import { PercentileCalculation } from '@marmon/shared/types/analysis';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-margin-percent-total-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class MarginPercentTotalCellComponent extends ColorCodeCellBase<number> {
	readonly percentiles = input.required<PercentileCalculation | null>();
	readonly toValue = inject(PercentToValuePipe);

	override readonly formattedValue = computed(() => {
		const value = this.value();
		if (value === undefined) return '0%';
		return this.toValue.transform(value);
	});

	override getColorCode(value: number): CellColorCode {
		const percentiles = this.percentiles();
		if (!percentiles) return 'gray';

		if (value >= percentiles[80]) return 'green';
		if (value >= percentiles[40]) return 'yellow';
		return 'red';
	}
}
